module.exports = __webpack_public_path__ + "static/img/djzlj.da9476b8.png";